import React from "react";
import PageHelmet from "../../components/shared/PageHelmet";
import HomeTwoHeader from "../HomeTwo/HomeTwoHeader/HomeTwoHeader";
import HomeTwoFooter from "../HomeTwo/HomeTwoFooter/HomeTwoFooter";
import CommonPageHeader from "../../components/CommonPageHeader/CommonPageHeader";
import ComplianceContent from "./ComplianceContent/ComplianceContent";

const Compliance = () => {
  return (
    <>
      <PageHelmet pageTitle="Compliance" />
      <HomeTwoHeader />
      <CommonPageHeader title="Compliance & Quality Assurance" subtitle="Our commitment to transparency and regulatory adherence" />
      <ComplianceContent />
      <HomeTwoFooter />
    </>
  );
};

export default Compliance;
